<template>
  <div class="container-fluid mt-4">
    <!-- Panel de Proveedores -->
    <div class="row">
      <div class="col-md-3 bg-white shadow-sm p-3 rounded">
        <h4 class="text-success mb-3">
          <font-awesome-icon icon="users" class="me-2" /> Proveedores
        </h4>

        <!-- Buscar Proveedor -->
        <input 
          type="text" 
          class="form-control mb-2" 
          placeholder="Buscar proveedor..." 
          v-model="searchTerm" 
          @input="filterProveedores" 
        />

        <!-- Lista Paginada de Proveedores -->
        <ul class="list-group">
          <li
            v-for="proveedor in proveedoresPaginados"
            :key="proveedor.id"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
            :class="{ active: proveedor.id === proveedorSeleccionado?.id }"
            @click="selectProveedor(proveedor)"
          >
            {{ proveedor.nombre }}
            <span v-if="proveedor.tiene_items_con_nivel_minimo" class="text-danger ms-2">
              <font-awesome-icon icon="exclamation-triangle" />
            </span>
          </li>
        </ul>

        <!-- Controles de paginación -->
        <div class="d-flex justify-content-between align-items-center mt-3">
          <button class="btn btn-secondary" @click="prevPage" :disabled="currentPage === 1">Anterior</button>
          <span>Página {{ currentPage }} de {{ totalPages }}</span>
          <button class="btn btn-secondary" @click="nextPage" :disabled="currentPage === totalPages">Siguiente</button>
        </div>

        <!-- Botón para Nuevo Proveedor -->
        <button 
          class="btn btn-success mt-3 w-100" 
          @click="cambiarMostrarAltaProveedor(true, null)"
        > 
          <font-awesome-icon icon="plus" class="me-2" /> Nuevo Proveedor
        </button>
      </div>

      <!-- Contenido Principal -->
      <div class="col-md-9" v-if="!mostrarAltaProveedor">
        <!-- Navbar para navegar entre las secciones -->
        <nav>
          <div class="nav nav-tabs mb-4" id="nav-tab" role="tablist">
            <button 
              class="nav-link" 
              :class="{ active: activeTab === 'inventario' }" 
              @click="activeTab = 'inventario'"
            >
              <font-awesome-icon icon="box" class="me-2" /> Inventario
            </button>
           
            <!-- 
           
            <button 
              class="nav-link" 
              :class="{ active: activeTab === 'ordenes' }" 
              @click="activeTab = 'ordenes'"
            >
              <font-awesome-icon icon="clipboard-list" class="me-2" /> Órdenes de Compra
            </button>
            -->
            <button
            class="nav-link"
            :class="{ active: activeTab === 'editarProveedor' }"
            @click="editarProveedor()"
            >
              <font-awesome-icon icon="pencil-alt" class="me-2" /> Editar Proveedor
            </button>

            <button 
              class="nav-link" 
              :class="{ active: activeTab === 'info' }" 
              @click="activeTab = 'info'"
            >
              <font-awesome-icon icon="info-circle" class="me-2" /> Info del Proveedor
            </button>
          </div>
        </nav>

        <!-- Contenido de las Pestañas -->
        <div>
          <div v-if="activeTab === 'inventario' && proveedorSeleccionado">
            <h4 class="text-success">
              <font-awesome-icon icon="box" class="me-2" /> Inventario
            </h4>
            <listarItemInventario :key="`inventario-${proveedorSeleccionado?.id}`" :proveedor_id="proveedorSeleccionado.id" />
          </div>
          <div v-else-if="activeTab === 'ordenes' && proveedorSeleccionado">
            <h4 class="text-success">
              <font-awesome-icon icon="clipboard-list" class="me-2" /> Órdenes de Compra
            </h4>
            <listarOrdenesDeCompra :key="`ordenes-${proveedorSeleccionado?.id}`" :proveedor_id="proveedorSeleccionado.id" />
          </div>
          <div v-else-if="activeTab === 'info' && proveedorSeleccionado">
            <h4 class="text-success">
              <font-awesome-icon icon="info-circle" class="me-2" /> Información del Proveedor
            </h4>
            <div class="card shadow-sm p-3 bg-light rounded">
              <p><strong>Nombre:</strong> {{ proveedorSeleccionado.nombre }}</p>
              <p><strong>Contacto:</strong> {{ proveedorSeleccionado.contacto }}</p>
              <p><strong>Teléfono:</strong> {{ proveedorSeleccionado.telefono }}</p>
              <p><strong>Dirección:</strong> {{ proveedorSeleccionado.direccion }}</p>
              <p><strong>Correo:</strong> {{ proveedorSeleccionado.correo }}</p>

              <button class="btn btn-danger mt-3" @click="borrarProveedor(proveedorSeleccionado)">
                <font-awesome-icon icon="trash" class="me-2" /> Eliminar Proveedor
              </button>
            </div>
          </div>
          <div v-else>
            <p class="text-muted">Seleccione un proveedor para ver su información.</p>
          </div>
        </div>
      </div>

      <!-- Alta de Proveedor -->
      <div class="col-md-9" v-else>
        <alta-proveedor 
          @cancelar="cambiarMostrarAltaProveedor(false)" 
          @guardar="guardarProveedor" 
          :proveedor="proveedorEnEdicion" 
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/axios';
import altaProveedor from '@/components/Inventario/alta-proveedor.vue';
import listarItemInventario from '@/components/Inventario/listar-ItemInventario.vue';
import listarOrdenesDeCompra from '@/components/Inventario/listar-ordenesDeCompra.vue';

export default {
  components: {
    altaProveedor,
    listarItemInventario,
    listarOrdenesDeCompra,
  },
  data() {
    return {
      proveedores: [],
      proveedoresFiltrados: [],
      proveedorSeleccionado: null,
      searchTerm: '',
      currentPage: 1,
      itemsPerPage: 5,
      activeTab: 'inventario', // Pestaña activa por defecto
      mostrarAltaProveedor: false,
      proveedorEnEdicion: null,
      clubActual: null,
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.proveedoresFiltrados.length / this.itemsPerPage);
    },
    proveedoresPaginados() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.proveedoresFiltrados.slice(start, start + this.itemsPerPage);
    },
  },
  methods: {
    async fetchProveedores() {
      try {
        const response = await axios.get('/api/proveedores',{params: { club_id: this.clubActual.id }});
        this.proveedores = response.data;

        for (let proveedor of this.proveedores) {
          const inventarioResponse = await axios.get(`/api/inventario/${proveedor.id}`, { params: { club_id: this.clubActual.id } });
          proveedor.tiene_items_con_nivel_minimo = inventarioResponse.data.some(item => item.cantidad < item.nivel_minimo);
        }
        this.proveedoresFiltrados = this.proveedores;
      } catch (error) {
        console.error('Error al obtener proveedores:', error);
      }
    },
    filterProveedores() {
      const term = this.searchTerm.toLowerCase();
      this.proveedoresFiltrados = this.proveedores.filter(proveedor =>
        proveedor.nombre.toLowerCase().includes(term)
      );
    },
    selectProveedor(proveedor) {
      this.proveedorSeleccionado = proveedor;
      this.cambiarMostrarAltaProveedor(false);
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage++;
    },
    cambiarMostrarAltaProveedor(valor, proveedor = null) {
      this.mostrarAltaProveedor = valor;
      this.proveedorEnEdicion = proveedor;
    },
    guardarProveedor(unProveedor) {
      console.log(unProveedor);
      if (unProveedor && unProveedor.id) {
        // Si existe, actualizar en la lista
        const idx = this.proveedores.findIndex(p => p.id === unProveedor.id);
        if (idx !== -1) {
          this.proveedores.splice(idx, 1, unProveedor);
        } else {
          this.proveedores.push(unProveedor);
        }
        // ACTUALIZAR proveedorSeleccionado si es el mismo
        if (this.proveedorSeleccionado && this.proveedorSeleccionado.id === unProveedor.id) {
          this.proveedorSeleccionado = unProveedor;
        }
      } else {
        this.proveedores.push(unProveedor);
      }
      this.proveedoresFiltrados = this.proveedores;
      this.mostrarAltaProveedor = false;
      this.proveedorEnEdicion = null;
    },
    borrarProveedor(proveedor) {
      if (confirm(`¿Estás seguro de eliminar a ${proveedor.nombre}?`)) {
        axios.delete(`/api/proveedores/${proveedor.id}`, { data: { club_id: this.clubActual.id } })
          .then(() => {
            alert('Proveedor eliminado exitosamente');
            this.proveedores = this.proveedores.filter(p => p.id !== proveedor.id);
            this.proveedoresFiltrados = this.proveedores;
            this.proveedorSeleccionado = null;
          })
          .catch(error => {
            alert('Error al eliminar proveedor: ' + error.response.data.error);
            console.error('Error al eliminar proveedor:', error);
          });
      }
    },
    editarProveedor() {
      if (this.proveedorSeleccionado) {
        this.cambiarMostrarAltaProveedor(true, this.proveedorSeleccionado);
      }
    },
  },
  mounted() {
    this.clubActual = this.$store.getters.getClubActual;
    this.fetchProveedores();
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/custom-bootstrap.scss';

.panel-left {
  min-width: 300px;
  background-color: $light;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.nav-tabs .nav-link {
  cursor: pointer;
  color: $dark;
  transition: background-color 0.3s ease;
}

.nav-tabs .nav-link.active {
  background-color: $success;
  color: white;
}

.card {
  background-color: $light;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

h4 {
  font-weight: bold;
  color: $dark;
}

.list-group-item.active {
  background-color: $success;
  color: white;
}

.list-group-item:hover {
  background-color: lighten($success, 20%);
}

.btn {
  transition: background-color 0.3s ease, color 0.3s ease;
}

.btn-success {
  background-color: $success;
  border-color: $success;
}

.btn-success:hover {
  background-color: lighten($success, 10%);
  border-color: lighten($success, 10%);
}

.btn-secondary {
  background-color: $dark;
  border-color: $dark;
  color: white;
}

.btn-secondary:hover {
  background-color: lighten($dark, 10%);
  border-color: lighten($dark, 10%);
}

.text-success {
  color: $success !important;
}

.text-muted {
  color: $dark !important;
}
</style>